import { useEffect, useRef, useState } from 'react';
import { api } from '@/lib/api';

export interface DriverLocation {
  driver_id: string;
  lat: number;
  lng: number;
  timestamp: string;
}

const POLL_INTERVAL = 10_000; // 10 seconds

export function useDriverTracking() {
  const [drivers, setDrivers] = useState<Map<string, DriverLocation>>(new Map());
  const [connected, setConnected] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const res = await api.get<{ driver_id: string; lat: number; lng: number }[]>(
          '/api/v1/dashboard/driver-locations',
        );
        const data = res.data || [];
        const now = new Date().toISOString();
        const next = new Map<string, DriverLocation>();
        data.forEach((d) => next.set(d.driver_id, { ...d, timestamp: now }));
        setDrivers(next);
        setConnected(true);
      } catch {
        setConnected(false);
      }
    };

    fetchLocations();
    intervalRef.current = setInterval(fetchLocations, POLL_INTERVAL);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  return { drivers, connected };
}
